import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getSticker,
  getStickers,
  insertStickers,
  updateStickers,
  deleteStickers,
  getCategoriaSticker,
  getCategoriasStickers,
  insertCategoriasStickers,
  updateCategoriasStickers,
  deleteCategoriasStickers,
  getStickerByCategoria,
} from 'services/personalizacion'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_STICKER(action) {
  try {
    const stickers = yield call(getSticker, action.id)
    if (stickers.ok) {
      yield put({
        type: actions.STICKERS_LOAD_SUCCEEDED,
        payload: stickers.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Tlos Stickers')
      put({
        type: actions.STICKERS_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.STICKERS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_STICKERS_CATEGORIA(action) {
  try {
    const stickers = yield call(getStickerByCategoria, action.idCategoria)
    if (stickers.ok) {
      yield put({
        type: actions.STICKERS_LOAD_SUCCEEDED,
        payload: stickers.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los Stickers')
      put({
        type: actions.STICKERS_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.STICKERS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_STICKERS(action) {
  try {
    const stickers = yield call(getStickers, action.deleted)
    if (stickers.ok) {
      yield put({
        type: actions.STICKERS_LOAD_SUCCEEDED,
        payload: stickers.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los Stickers')
      put({
        type: actions.STICKERS_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.STICKERS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_STICKERS(action) {
  try {
    const sticker = yield call(insertStickers, action.payload)
    if (sticker.ok) {
      putMessage(messageType.SUCCESS, 'Sticker creado correctamente')
      yield put({
        type: actions.STICKERS_INSERT_SUCCEEDED,
        payload: sticker.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear sticker')
      yield put({
        type: actions.STICKERS_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear sticker')
    yield all([
      put({
        type: actions.STICKERS_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_STICKERS(action) {
  try {
    const sticker = yield call(updateStickers, action.payload)
    if (sticker.ok) {
      putMessage(messageType.SUCCESS, 'Sticker modificado correctamente')
      yield put({
        type: actions.STICKERS_UPDATE_SUCCEEDED,
        payload: sticker.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar sticker')
      yield put({
        type: actions.STICKERS_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar sticker')
    yield all([
      put({
        type: actions.STICKERS_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_STICKERS(action) {
  try {
    const sticker = yield call(deleteStickers, action.id)
    if (sticker.ok) {
      putMessage(messageType.SUCCESS, 'Sticker eliminado correctamente')
      yield put({
        type: actions.STICKERS_DELETE_SUCCEEDED,
        id: action.id,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar sticker')
      yield put({
        type: actions.STICKERS_DELETE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar sticker')
    yield all([
      put({
        type: actions.STICKERS_DELETE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CATEGORIA_STICKER(action) {
  try {
    const stickers = yield call(getCategoriaSticker, action.id)
    if (stickers.ok) {
      yield put({
        type: actions.STICKERS_LOAD_SUCCEEDED,
        payload: stickers.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar la categoria')
      put({
        type: actions.STICKERS_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.STICKERS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CATEGORIAS_STICKERS(action) {
  try {
    const stickers = yield call(getCategoriasStickers, action.deleted)
    if (stickers.ok) {
      yield put({
        type: actions.CATEGORIAS_STICKERS_LOAD_SUCCEEDED,
        payload: stickers.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar las categorias')
      put({
        type: actions.CATEGORIAS_STICKERS_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CATEGORIAS_STICKERS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_CATEGORIAS_STICKERS(action) {
  try {
    const sticker = yield call(insertCategoriasStickers, action.payload)
    if (sticker.ok) {
      putMessage(messageType.SUCCESS, 'Categoria creada correctamente')
      yield put({
        type: actions.CATEGORIAS_STICKERS_INSERT_SUCCEEDED,
        payload: sticker.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear categoria')
      yield put({
        type: actions.CATEGORIAS_STICKERS_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear categoria')
    yield all([
      put({
        type: actions.CATEGORIAS_STICKERS_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_CATEGORIAS_STICKERS(action) {
  try {
    const sticker = yield call(updateCategoriasStickers, action.payload)
    if (sticker.ok) {
      putMessage(messageType.SUCCESS, 'Categoria modificada correctamente')
      yield put({
        type: actions.CATEGORIAS_STICKERS_UPDATE_SUCCEEDED,
        payload: sticker.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar categoria')
      yield put({
        type: actions.CATEGORIAS_STICKERS_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar categoria')
    yield all([
      put({
        type: actions.CATEGORIAS_STICKERS_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_CATEGORIAS_STICKERS(action) {
  try {
    const sticker = yield call(deleteCategoriasStickers, action.id)
    if (sticker.ok) {
      putMessage(messageType.SUCCESS, 'Categoria eliminada correctamente')
      yield put({
        type: actions.CATEGORIAS_STICKERS_DELETE_SUCCEEDED,
        payload: action.id,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar categoria')
      yield put({
        type: actions.CATEGORIAS_STICKERS_DELETE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar categoria')
    yield all([
      put({
        type: actions.CATEGORIAS_STICKERS_DELETE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* CATEGORIAS_STICKERS_RESET_COUNTER(action) {
  try {
    const sticker = yield call(updateCategoriasStickers, action.payload)
    if (sticker.ok) {
      putMessage(messageType.SUCCESS, 'Categoria modificada correctamente')
      yield put({
        type: actions.CATEGORIAS_STICKERS_RESET_COUNTER_SUCCEEDED,
        payload: sticker.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar categoria')
      yield put({
        type: actions.CATEGORIAS_STICKERS_RESET_COUNTER_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar categoria')
    yield all([
      put({
        type: actions.CATEGORIAS_STICKERS_RESET_COUNTER_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.STICKERS_LOAD_REQUESTED, GET_STICKERS),
    takeEvery(actions.STICKERS_CATEGORIA_LOAD_REQUESTED, GET_STICKERS_CATEGORIA),
    takeEvery(actions.STICKERS_INSERT_REQUESTED, INSERT_STICKERS),
    takeEvery(actions.STICKERS_UPDATE_REQUESTED, UPDATE_STICKERS),
    takeEvery(actions.STICKERS_DELETE_REQUESTED, DELETE_STICKERS),
    takeEvery(actions.CATEGORIAS_STICKERS_LOAD_REQUESTED, GET_CATEGORIAS_STICKERS),
    takeEvery(actions.CATEGORIAS_STICKERS_INSERT_REQUESTED, INSERT_CATEGORIAS_STICKERS),
    takeEvery(actions.CATEGORIAS_STICKERS_UPDATE_REQUESTED, UPDATE_CATEGORIAS_STICKERS),
    takeEvery(actions.CATEGORIAS_STICKERS_DELETE_REQUESTED, DELETE_CATEGORIAS_STICKERS),
    takeEvery(
      actions.CATEGORIAS_STICKERS_RESET_COUNTER_REQUESTED,
      CATEGORIAS_STICKERS_RESET_COUNTER,
    ),
  ])
}
